import React from "react";
import { ArrowRight, MapPin } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_59327c5f-9084-4487-a3b9-37467c30053c/artifacts/09w9qdg0_IMG_5550.jpeg";

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 md:pt-36 pb-20 md:pb-28 overflow-hidden warm-glow"
    >
      <div className="absolute inset-0 grain-overlay" aria-hidden="true" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        {/* Overline */}
        <div className="flex items-center justify-center gap-3 mb-8 reveal">
          <span className="h-px w-10 bg-[#C89D54]" />
          <span className="overline">Professional McKenzie Friend</span>
          <span className="h-px w-10 bg-[#C89D54]" />
        </div>

        {/* Stats — placed above the portrait */}
        <div
          className="mb-10 flex items-center justify-center gap-8 md:gap-12 text-sm text-[#A6A098] reveal"
          style={{ animationDelay: "60ms" }}
        >
          <div className="text-center">
            <div className="font-serif-display text-3xl md:text-4xl text-[#F4F0EB]">
              15<span className="text-[#C89D54]">+</span>
            </div>
            <div className="text-xs uppercase tracking-widest mt-1">
              Years as Bailiff
            </div>
          </div>
          <div className="h-12 w-px bg-[#C89D54]/30" />
          <div className="text-center">
            <div className="font-serif-display text-3xl md:text-4xl text-[#F4F0EB]">
              LLB (Honours)
            </div>
            <div className="text-xs uppercase tracking-widest mt-1">
              Law degree
            </div>
          </div>
          <div className="h-12 w-px bg-[#C89D54]/30" />
          <div className="text-center">
            <div className="font-serif-display text-3xl md:text-4xl text-[#F4F0EB]">
              4
            </div>
            <div className="text-xs uppercase tracking-widest mt-1">
              Counties Covered
            </div>
          </div>
        </div>

        {/* Hero portrait — positioned between overline and the first content point */}
        <div
          className="relative mx-auto max-w-2xl reveal"
          style={{ animationDelay: "100ms" }}
        >
          <div className="absolute -top-4 -left-4 h-20 w-20 border-t border-l border-[#C89D54]/60 z-10" />
          <div className="absolute -bottom-4 -right-4 h-20 w-20 border-b border-r border-[#C89D54]/60 z-10" />

          <div className="image-frame bg-[#262321]">
            <img
              data-testid="hero-portrait"
              src={HERO_IMG}
              alt="Michael Skierniewski – Professional McKenzie Friend based in Mansfield"
              className="w-full h-[360px] md:h-[460px] object-cover object-[center_22%]"
              loading="eager"
            />
          </div>
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-headline"
          className="mt-14 md:mt-16 text-center font-serif-display text-[2.6rem] leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl text-[#F4F0EB] tracking-tight reveal"
          style={{ animationDelay: "200ms" }}
        >
          Family Court Help
          <span className="block italic text-[#C89D54] mt-2">
            done properly.
          </span>
        </h1>

        {/* Locations */}
        <p
          data-testid="hero-locations"
          className="mt-6 text-center font-sans-body text-base md:text-lg leading-relaxed reveal"
          style={{ animationDelay: "260ms" }}
        >
          <span className="inline-flex items-center gap-2 text-[#F4F0EB] font-medium">
            <MapPin size={16} className="text-[#C89D54]" /> Mansfield ·
            Nottinghamshire · Derbyshire · Sheffield
          </span>
        </p>

        {/* Subtext */}
        <p
          data-testid="hero-subtext"
          className="mt-6 mx-auto max-w-2xl text-center font-sans-body text-[15px] md:text-base text-[#A6A098] leading-relaxed reveal"
          style={{ animationDelay: "320ms" }}
        >
          With 15 years&apos; experience working as a bailiff and complemented
          by an LLB (Honours) Law degree. I provide practical, reliable support to
          people representing themselves in the Family Court. I assist with
          child arrangements, financial remedy, divorce proceedings and
          enforcement of court orders.
        </p>

        {/* CTAs */}
        <div
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center reveal"
          style={{ animationDelay: "380ms" }}
        >
          <button
            data-testid="hero-cta-consult"
            onClick={() => scrollTo("contact")}
            className="btn-primary"
          >
            Book a Free 20-Minute Consultation
            <ArrowRight size={16} />
          </button>
          <button
            data-testid="hero-cta-services"
            onClick={() => scrollTo("services")}
            className="btn-secondary"
          >
            View Services
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
